module.exports = __webpack_public_path__ + "img/rQR_f.8947e471.png";